import { DIRECTUS } from 'drapcode-constant';
import { alertMessagesArgsConfig, browserStorageArgsConfig } from '../../utils/event_constants';

export const directusActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'Directus: Sign Up',
    type: 'AUTH',
    source: DIRECTUS,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsDirectus',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Directus: Sign In via Email & Password',
    type: 'AUTH',
    source: DIRECTUS,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsDirectus',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Directus: Sign Out',
    type: 'AUTH',
    source: DIRECTUS,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsDirectus',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'authorizeWithExternalDataSource',
    label: 'Directus: Authorize Using API',
    type: 'AUTH',
    source: DIRECTUS,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsDirectus',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Directus: Send Data To API',
    source: DIRECTUS,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsDirectus',
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
];
